import {token} from "@atlaskit/tokens";
import {AnankeText} from "@vesta/ananke/components/anankeText";
import type {ProfileOverviewMetric} from "~/components/entityProfile/overview/types";
import {ProfileOverviewSectionHeader} from "~/components/entityProfile/overview/profileOverviewSectionHeader";

const METRIC_CARD_CLASS_NAME =
    "box-border flex h-[78px] w-full min-w-0 flex-col items-start justify-center gap-y-ds-space-050 px-ds-space-150";

const metricCardStyle = {
    borderRadius: 4,
    border: `1px solid ${token("color.border")}`,
    backgroundColor: token("elevation.surface.overlay"),
    boxShadow: "0 0 1px 0 rgba(30, 31, 33, 0.31), 0 1px 1px 0 rgba(30, 31, 33, 0.25)",
} as const;

const metricCardValueStyle = {
    display: "flex",
    alignItems: "center",
    minWidth: 18,
    height: 32,
    fontFamily: "Inter",
    fontSize: "var(--Font-Size-Heading-XL, 28px)",
    fontStyle: "normal",
    fontWeight: "var(--Font-Weight-Heading, 653)",
    lineHeight: "var(--Line-Height-Heading-XL, 32px)",
    color: token("color.text"),
} as const;

function ProfileOverviewMetricCard({metric}: {metric: ProfileOverviewMetric}) {
    return (
        <div className="w-[112px] shrink-0 md:min-w-0 md:w-auto md:flex-1 md:basis-0">
            <div className={METRIC_CARD_CLASS_NAME} style={metricCardStyle}>
                <AnankeText size="small" color="color.text.subtlest" className="whitespace-nowrap">
                    {metric.label}
                </AnankeText>
                <span style={metricCardValueStyle}>{metric.value}</span>
            </div>
        </div>
    );
}

export function ProfileOverviewMetricStrip({
    title,
    metrics,
}: {
    title: string;
    metrics: ProfileOverviewMetric[];
}) {
    if (metrics.length === 0) {
        return null;
    }

    return (
        <section className="grid w-full min-w-0 gap-y-ds-space-100">
            <ProfileOverviewSectionHeader title={title} />
            <div className="w-full min-w-0 overflow-x-auto overscroll-x-contain [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:overflow-x-visible">
                <div className="flex w-max min-w-full gap-ds-space-100 md:w-full">
                    {metrics.map((metric) => (
                        <ProfileOverviewMetricCard key={metric.id} metric={metric} />
                    ))}
                </div>
            </div>
        </section>
    );
}
